
import { Component, Prop, Vue } from 'vue-property-decorator'
import TicketScgl from '@/views/Ticket/indexScgl.vue'

@Component({
  name: 'AllMyCreatedOrderLists',
  components: {
    TicketScgl
  }
})
export default class extends Vue {}
